export type EvseCongigValues = {
  brand: 'Hager' | 'Audi'
  category: 'ModbusTCP' | 'EEBus'
  type: 'WittyLink' | 'WittyFlex' | 'Cintech' | 'EEBus'
  defaultNameTranslationKey: string
}

export const evseDevicesConfig = {
  'XVL122C / XVL122S': {
    brand: 'Hager',
    category: 'ModbusTCP',
    type: 'WittyLink',
    defaultNameTranslationKey: 'installation.evseEditor.wallBoxDefaults.wittyLink',
  },
  XDV111E: {
    brand: 'Hager',
    category: 'ModbusTCP',
    type: 'WittyFlex',
    defaultNameTranslationKey: 'installation.evseEditor.wallBoxDefaults.wittyFlex',
  },
  'XEV1K07T2S / XEV1K22T2S': {
    brand: 'Hager',
    category: 'ModbusTCP',
    type: 'Cintech',
    defaultNameTranslationKey: 'installation.evseEditor.wallBoxDefaults.ModbusTCP',
  },
  XEV1S22T2TF: {
    brand: 'Hager',
    category: 'EEBus',
    type: 'EEBus',
    defaultNameTranslationKey: 'installation.evseEditor.wallBoxDefaults.EEBus',
  },
  '8V4, 9Y0': {
    brand: 'Audi',
    category: 'EEBus',
    type: 'EEBus',
    defaultNameTranslationKey: 'installation.evseEditor.wallBoxDefaults.EEBus',
  },
} as const satisfies Record<string, EvseCongigValues>

type EvseConfig = typeof evseDevicesConfig

export type EvseBrand = EvseConfig[keyof EvseConfig]['brand']
export type EvseReference = keyof EvseConfig
export type EvseCategory = EvseConfig[keyof EvseConfig]['category']

export const getEvseCategory = (reference: EvseReference): EvseCategory => {
  return evseDevicesConfig[reference].category
}
